import {
  AccordionContent,
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionTitleText,
  AccordionTrigger,
} from "ui/gluestack/accordion";
import { Text, View } from "react-native";
import { format } from "date-fns";
import { ChevronDownIcon, ChevronUpIcon } from "ui/gluestack/icon";
import KeyValueGrid from "ui/organisms/KeyValueGrid";
import { BowelMovementReportResponse } from "../../../services/api/types/forms/responses/BowelMovementReportResponse";
import { useMemo } from "react";
import { getFullName } from "ui/utils/nameUtil";

interface Props {
  log: BowelMovementReportResponse;
}

export function BowelMovementHistoryItem({ log }: Props) {
  const createdBy = useMemo(() => {
    return getFullName(log.user);
  }, [log?.user]);

  const otherComments = useMemo(
    () => [{ label: "Other Comments", value: log.other_comments ?? "N/A" }],
    [log],
  );

  const bowelMovementLogs = useMemo(
    () => [
      {
        label: "Enema/Suppositories Done",
        value: log.enema_suppositories_done ? "Yes" : "No",
      },
      { label: "Bowels Opened", value: log.bowels_opened ? "Yes" : "No" },
      { label: "Voiding Place", value: log.voiding_place ?? "N/A" },
      {
        label: "Voiding Place Description",
        value: log.voiding_place_description ?? "N/A",
      },
      { label: "Stool Type", value: log.stool_type ?? "N/A" },
      { label: "Recorded By", value: createdBy ?? "N/A" },
    ],
    [log],
  );

  return (
    <AccordionItem
      key={log.id}
      value={`${log.id}`}
      className="border rounded-lg border-border-200 p-2"
    >
      <AccordionHeader>
        <AccordionTrigger className="focus:web:rounded-lg">
          {({ isExpanded }) => (
            <>
              <View className="flex-row items-center">
                <AccordionTitleText className="mr-1">
                  <Text className="capitalize">
                    {log.voiding_place ?? "N/A"}
                  </Text>
                  <Text>
                    {log.voiding_place_description &&
                      ` - ${log.voiding_place_description}`}
                  </Text>
                </AccordionTitleText>
                <Text className="text-xs font-medium text-typography-600">
                  - {format(new Date(log.created_at), "dd-MM-yyyy 'at' HH:mm")}
                </Text>
              </View>
              {isExpanded ? (
                <AccordionIcon as={ChevronUpIcon} />
              ) : (
                <AccordionIcon as={ChevronDownIcon} />
              )}
            </>
          )}
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent>
        <View>
          <KeyValueGrid items={bowelMovementLogs} />
        </View>
        <View className="border border-gray-200 w-full my-8" />
        <View>
          <KeyValueGrid items={otherComments} />
        </View>
      </AccordionContent>
    </AccordionItem>
  );
}
